<template>
  <div class="flex justify-between">
    <div class="flex items-center gap-1">
      <CardActionButton
        icon="outline_fire"
        :count="reactions[ReactionType.Fire]?.count || 0"
        :title="$t('common.likes')"
        :is-active="reactions[ReactionType.Fire]?.is_set_by_user"
        :is-processing="isCountersProcessing"
        @click="onChangeReaction(ReactionType.Fire)"
      />
      <template v-if="comments !== undefined">
        <template v-if="commentsRoute">
          <BaseLocaleLink :to="commentsRoute" class="flex no-underline">
            <CardActionButton
              icon="outline_chat_bubble"
              :count="comments"
              :title="$t('common.comments')"
            />
          </BaseLocaleLink>
        </template>
        <template v-else>
          <CardActionButton
            icon="outline_chat_bubble"
            class="pointer-events-none"
            :count="comments"
            :title="$t('common.comments')"
          />
        </template>
      </template>
      <CardActionButton
        icon="outline_share"
        :title="$t('common.share')"
        @click="openShareModal"
      />
    </div>
    <slot />
    <ShareModal
      :is-open="isShareModalOpen"
      :link="pageLink"
      :title="name"
      @close="closeShareModal"
    />
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import { ReactionType } from '~/models/counters'
import type { ReactionsCounters } from '~/models/counters'

interface PropsInterface {
  name: string
  comments?: number
  reactions: ReactionsCounters
  pageLink: string
  isCountersProcessing: boolean
  route?: RouteLocationRaw
}

const props = defineProps<PropsInterface>()

const emit = defineEmits(['change-reaction'])

const isShareModalOpen = ref(false)

const openShareModal = () => {
  isShareModalOpen.value = true
}

const closeShareModal = () => {
  isShareModalOpen.value = false
}

const commentsRoute = computed(() => {
  if (typeof props.route === 'object') {
    return {
      ...props.route,
      ...{
        query: {
          scroll: 'comments',
        },
      },
    }
  }
  return props.route
})

const onChangeReaction = (reactionType: ReactionType) => {
  emit('change-reaction', reactionType)
}
</script>
